import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Giriş sayfası gibi: zaten oturum açıksa (ör. geri tuşu) ana sayfaya yönlendirir.
 */
export function GuestOnlyRoute({ children, redirectTo = '/' }) {
    const { isAuthenticated, ready } = useAuth();

    if (!ready) {
        return (
            <div className="text-center text-secondary py-5" role="status">
                Yükleniyor…
            </div>
        );
    }

    if (isAuthenticated) {
        return <Navigate to={redirectTo} replace />;
    }

    return children;
}
